import React from 'react';

interface Props {}

const RequiredStar: React.FC<Props> = () => {
  return <span className="font-bold text-red-500">*</span>;
};

export default RequiredStar;
